// tabs/ServiciiTab.js
import React, { useState, useEffect } from "react";
import axios from "axios";
import { Checkbox } from "@mui/material";
import {
  Box,
  Button,
  Card,
  CardContent,
  FormControlLabel,
  Grid,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Paper,
} from "@mui/material";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import RefreshIcon from "@mui/icons-material/Refresh";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

function ServiciiTab() {
  const [isFilteredServiciiStartDate, setIsFilteredServiciiStartDate] =
    useState(null);
  const [isFilteredServiciiEndDate, setIsFilteredServiciiEndDate] =
    useState(null);
  const [isToggleActive, setIsToggleActive] = useState(false);
  const [isSyncing, setIsSyncing] = useState(false);

  const [localData, setLocalData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [totalSuma, setTotalSuma] = useState(0);
  const [totalComenzi, setTotalComenzi] = useState(0);

  const handleToggleChange = (event) => setIsToggleActive(event.target.checked);

  const handleSyncProducts = () => {
    setIsSyncing(true);
    fetch("https://server-9p4hx.kinsta.app/update-woocommerce-orders")
      .then((res) => res.json())
      .then(() => alert("Stocurile au fost actualizate."))
      .catch((err) => console.error(err))
      .finally(() => setIsSyncing(false));
  };

  useEffect(() => {
    const fetchServicii = async () => {
      try {
        const response = await axios.get(
          "https://server-9p4hx.kinsta.app/api/jurnale/servicii"
        );
        const data = response.data.filteredData.concat(
          response.data.filteredData2 || []
        );
        setLocalData(data);
        setFilteredData(data);
      } catch (error) {
        console.error("Eroare la preluarea serviciilor:", error);
      }
    };
    fetchServicii();
  }, []);

  useEffect(() => {
    const filtered = localData.filter((order) => {
      const date = new Date(order.date_created);
      const inDateRange =
        (!isFilteredServiciiStartDate || date >= isFilteredServiciiStartDate) &&
        (!isFilteredServiciiEndDate || date <= isFilteredServiciiEndDate);
      const toggleMatch =
        !isToggleActive ||
        (order.product_name && order.product_name.includes("LCE"));
      return inDateRange && toggleMatch;
    });
    setFilteredData(filtered);
    const suma = filtered.reduce((acc, curr) => {
      const value = parseFloat(curr.total);
      return acc + (isNaN(value) ? 0 : value);
    }, 0);
    setTotalSuma(suma);
    setTotalComenzi(filtered.length);
  }, [
    localData,
    isFilteredServiciiStartDate,
    isFilteredServiciiEndDate,
    isToggleActive,
  ]);

  const handleRecChange = async (issue_id, newRecValue) => {
    try {
      const response = await axios.post(
        "https://server-9p4hx.kinsta.app/api/jurnale/update-rec",
        {
          issue_id,
          rec: newRecValue ? 1 : 0,
        }
      );
      if (response.status === 200) {
        const updated = filteredData.map((row) =>
          row.issue_id === issue_id ? { ...row, rec: newRecValue ? 1 : 0 } : row
        );
        setFilteredData(updated);
      }
    } catch (error) {
      console.error("Eroare la actualizarea valorii REC:", error);
    }
  };

  return (
    <>
      <Box
        sx={{ display: "flex", justifyContent: "space-between", padding: 4 }}
      >
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
          <Typography>De la:</Typography>
          <DatePicker
            selected={isFilteredServiciiStartDate}
            onChange={(date) => setIsFilteredServiciiStartDate(date)}
            selectsStart
            startDate={isFilteredServiciiStartDate}
            endDate={isFilteredServiciiEndDate}
            dateFormat="dd/MM/yyyy"
            isClearable
            placeholderText="Selectează data de început"
          />
        </Box>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
          <Typography>Până la:</Typography>
          <DatePicker
            selected={isFilteredServiciiEndDate}
            onChange={(date) => setIsFilteredServiciiEndDate(date)}
            selectsEnd
            startDate={isFilteredServiciiStartDate}
            endDate={isFilteredServiciiEndDate}
            dateFormat="dd/MM/yyyy"
            isClearable
            placeholderText="Selectează data de sfârșit"
          />
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 1,
          }}
        >
          <Typography>Doar LCE Pachete</Typography>
          <FormControlLabel
            control={
              <Switch checked={isToggleActive} onChange={handleToggleChange} />
            }
            label=""
          />
        </Box>
        {/* <Button variant="contained" startIcon={<CloudDownloadIcon />} onClick={exportFilteredSalesToExcel}>
          Export Excel
        </Button>
        <Button variant="contained" startIcon={<CloudDownloadIcon />} onClick={exportFilteredSalesToPDF}>
          Export PDF
        </Button> */}
        <Button
          variant="outlined"
          startIcon={<RefreshIcon />}
          onClick={handleSyncProducts}
          disabled={isSyncing}
        >
          {isSyncing ? "Sincronizare..." : "Reîncarcă stocuri"}
        </Button>
      </Box>

      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: 2,
          marginBottom: 2,
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <Card
              variant="outlined"
              sx={{ display: "flex", alignItems: "center", padding: 2 }}
            >
              <AttachMoneyIcon
                color="primary"
                sx={{ fontSize: 40, marginRight: 2 }}
              />
              <CardContent>
                <Typography color="textSecondary">Total Suma</Typography>
                <Typography variant="h5">
                  {(totalSuma || 0).toLocaleString("ro-RO", {
                    maximumFractionDigits: 2,
                  })}{" "}
                  RON
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} md={4}>
            <Card
              variant="outlined"
              sx={{ display: "flex", alignItems: "center", padding: 2 }}
            >
              <AccountBalanceWalletIcon
                color="primary"
                sx={{ fontSize: 40, marginRight: 2 }}
              />
              <CardContent>
                <Typography color="textSecondary">Total Comenzi</Typography>
                <Typography variant="h5">{totalComenzi ?? 0}</Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} md={4}>
            <Card
              variant="outlined"
              sx={{ display: "flex", alignItems: "center", padding: 2 }}
            >
              <MonetizationOnIcon
                color="secondary"
                sx={{ fontSize: 40, marginRight: 2 }}
              />
              <CardContent>
                <Typography color="textSecondary">Bonus</Typography>
                <Typography variant="h5">
                  {(totalSuma || 0) > 4000
                    ? `${((totalSuma || 0) - 4000).toLocaleString("ro-RO", { maximumFractionDigits: 2 })} RON`
                    : "0 RON"}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Box>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>REC</TableCell>
              <TableCell>Nr. Comanda</TableCell>
              <TableCell>SKU</TableCell>
              <TableCell>First Name</TableCell>
              <TableCell>Last Name</TableCell>
              <TableCell>Email</TableCell>
              <TableCell>Telefon</TableCell>
              <TableCell>Date Created</TableCell>
              <TableCell>Total</TableCell>
              <TableCell>Subtotal</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredData.map((row, index) => (
              <TableRow key={index}>
                <TableCell>
                  <Checkbox
                    checked={row.rec === 1 || row.rec === "1"}
                    onChange={() =>
                      handleRecChange(
                        row.issue_id,
                        !(row.rec === 1 || row.rec === "1")
                      )
                    }
                  />
                </TableCell>
                <TableCell>{row.ID}</TableCell>
                <TableCell>{row.sku}</TableCell>
                <TableCell>{row.first_name}</TableCell>
                <TableCell>{row.last_name}</TableCell>
                <TableCell>{row.email}</TableCell>
                <TableCell>{row.phone}</TableCell>
                <TableCell>
                  {new Date(row.date_created).toLocaleDateString()}
                </TableCell>
                <TableCell>{row.total}</TableCell>
                <TableCell>{row.subtotal}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}

export default ServiciiTab;
